module.exports = __webpack_public_path__ + "img/logo-usisoftware.82f8aeb3.png";